import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import MaterialIcon from '../MaterialIcon';

function ListElement({ item, handleCheckboxChange, page, itemMethods }) {
	const handleCounterIncrement = () => {
		let itemToModify = JSON.parse(JSON.stringify(item));
		let newQuantity;
		if (item.quantity === '') {
			newQuantity = item.quantity + 1;
		} else {
			newQuantity = parseInt(item.quantity) + 1;
		}

		if (newQuantity > 0 && newQuantity <= 999) {
			itemToModify.quantity = newQuantity;
			itemMethods.edit(itemToModify);
		}
	};

	const handleCounterDecrement = () => {
		let itemToModify = JSON.parse(JSON.stringify(item));
		let newQuantity;
		if (item.quantity === '') {
			newQuantity = 0;
		} else {
			newQuantity = parseInt(item.quantity) - 1;
		}
		if (newQuantity > 0 && newQuantity <= 999) {
			itemToModify.quantity = newQuantity;
			itemMethods.edit(itemToModify);
		}
	};

	let checkedItemClass = '';
	if (item.checked && page === '/products') {
		checkedItemClass = 'productElement--checked';
	} else if (item.checked) {
		checkedItemClass = 'listItem--checked';
	}

	return (
		<li className={`listItem ${checkedItemClass}`}>
			{page ? (
				<Fragment>
					<label name="Check List Item" htmlFor={`listEl-${item.id}`} />
					<input
						id={`listEl-${item.id}`}
						className={`listItem__checkbox`}
						checked={item.checked ? true : false}
						type="checkbox"
						onChange={(e) => handleCheckboxChange(e.target)}
						value={item.id}
						data-type={item.type}
					/>
					<Link to={`${page}/${item.id}`} className="listItem__editLink">
						<p
							className={`listItem__name ${item.checked && page === '/lists'
								? 'listItem__name--checked'
								: ''}`}
						>
							{item.name}
						</p>
						{/* If the item has a quantity, show the counter */}
						{item.quantity && page !== '/products' ? (
							<div className={'itemCounter'}>
								<button
									className="itemCounter__Buttons"
									onClick={(e) => {
										e.preventDefault();
										handleCounterDecrement();
									}}
								>
									<MaterialIcon>remove</MaterialIcon>
								</button>
								<p className="listItem__quantity">{item.quantity}</p>
								<button
									className="itemCounter__Buttons"
									onClick={(e) => {
										e.preventDefault();
										handleCounterIncrement();
									}}
								>
									<MaterialIcon>add</MaterialIcon>
								</button>
							</div>
						) : (
							''
						)}

						<button
							className="listItem__deleteBtn"
							onClick={(e) => {
								e.preventDefault();
								itemMethods.delete(item.id, item.type);
							}}
						>
							<i className="material-icons">delete</i>
						</button>
					</Link>
				</Fragment>
			) : (
				<Fragment>
					<label name="Check List Item" htmlFor={`listEl-${item.id}`} />
					<input
						id={`listEl-${item.id}`}
						className={`listItem__checkbox`}
						checked={item.checked ? true : false}
						type="checkbox"
						onChange={(e) => handleCheckboxChange(e.target)}
						value={item.id}
						data-type={item.type}
					/>
					<p className={`listItem__name ${item.checked ? 'listItem__name--checked' : ''}`}>{item.name}</p>
					<p className="listItem__quantity">{item.quantity}</p>
				</Fragment>
			)}
		</li>
	);
}

export default ListElement;
